import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

export default function PrivacyPolicy() {
  return (
    <div className="privacy">
      <nav className="privacy__nav">
        <Link to="/" className="privacy__back">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to Dwellia
        </Link>
      </nav>

      <main className="privacy__content">
        <h1>Privacy Policy</h1>
        <p className="privacy__effective">Effective Date: April 8, 2026</p>

        <p>
          Dwellia ("we," "us," or "our") operates the website at{' '}
          <strong>dwellia.co</strong> (the "Service"). This Privacy Policy explains
          what information we collect, how we use it, and your choices.
        </p>

        <h2>1. Information We Collect</h2>

        <h3>Account Information</h3>
        <p>
          When you create an account, we collect your <strong>email address</strong> and
          a password. You may also sign in with Google, in which case Google shares your
          name and email address with us. Authentication is handled by Firebase
          Authentication; we never store your password directly.
        </p>

        <h3>User Preferences &amp; Saved Data</h3>
        <p>
          If you are signed in, we store your preferences (e.g., filter settings, map
          layer choices), saved searches, and favorite places in Firebase Firestore so
          they sync across sessions. If you are not signed in, these are stored only in
          your browser's local storage.
        </p>

        <h3>Search Queries</h3>
        <p>
          When you search for an address, city, or ZIP code, your query is sent to
          Google Places API to return autocomplete suggestions and map results. We cache
          some search results on our server to reduce repeated API calls but do not use
          them for profiling or advertising.
        </p>

        <h3>Feedback Submissions</h3>
        <p>
          If you submit license-URL feedback, we collect the email address and message
          you provide and send it via email to our team.
        </p>

        <h3>Automatically Collected Information</h3>
        <p>
          We do not use analytics, tracking pixels, or advertising SDKs. Standard web
          server logs (IP address, browser type, timestamps) may be collected by our
          hosting provider, Firebase Hosting, as part of normal operations.
        </p>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>To provide, maintain, and improve the Service.</li>
          <li>To authenticate your identity and manage your account.</li>
          <li>To save your preferences, favorites, and searches so they persist across sessions.</li>
          <li>To respond to feedback you submit.</li>
          <li>To cache third-party API results and improve performance.</li>
        </ul>
        <p>We do not sell, rent, or share your personal information with third parties for their marketing purposes.</p>

        <h2>3. Third-Party Services</h2>
        <p>We use the following third-party services that may process data on our behalf:</p>
        <ul>
          <li>
            <strong>Firebase (Google)</strong> — Authentication, Firestore database, and hosting.
            See the{' '}
            <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">
              Firebase Privacy Policy
            </a>.
          </li>
          <li>
            <strong>Google Maps &amp; Places API</strong> — Map rendering, address
            autocomplete, and place search.
            See the{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
              Google Privacy Policy
            </a>.
          </li>
        </ul>

        <h2>4. Cookies &amp; Local Storage</h2>
        <p>
          We do not set first-party cookies. Firebase may set cookies for authentication.
          We use your browser's local storage to save guest preferences, recent
          searches, and theme settings. You can clear local storage at any time through
          your browser settings.
        </p>

        <h2>5. Data Retention</h2>
        <p>
          We retain your account data and preferences for as long as your account is
          active. Cached third-party data (e.g., place search results) is retained
          temporarily (24–72 hours) to improve performance. You may delete your account
          by contacting us, and we will remove your data from Firestore.
        </p>

        <h2>6. Data Security</h2>
        <p>
          All data is transmitted over HTTPS. Passwords are managed by Firebase
          Authentication and are never accessible to us in plaintext. While we take
          reasonable measures to protect your data, no method of electronic
          transmission or storage is 100% secure.
        </p>

        <h2>7. Children's Privacy</h2>
        <p>
          The Service is not directed to children under 13. We do not knowingly collect
          personal information from children under 13. If you believe we have
          inadvertently collected such information, please contact us so we can delete
          it.
        </p>

        <h2>8. Your Rights</h2>
        <p>Depending on your jurisdiction, you may have the right to:</p>
        <ul>
          <li>Access the personal information we hold about you.</li>
          <li>Request correction or deletion of your personal data.</li>
          <li>Object to or restrict certain processing of your data.</li>
          <li>Request a portable copy of your data.</li>
        </ul>
        <p>
          To exercise any of these rights, please contact us at the email below.
        </p>

        <h2>9. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. If we make material
          changes, we will update the "Effective Date" at the top of this page. Your
          continued use of the Service after changes constitutes acceptance of the
          updated policy.
        </p>

        <h2>10. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy, you can reach us at:{' '}
          <a href="mailto:luketorr1297@gmail.com">luketorr1297@gmail.com</a>
        </p>
      </main>
    </div>
  );
}
